import IncidentListToolbar from '@/views/incident/toolbars/IncidentListToolbar';
import IncidentViewToolbar from '@/views/incident/toolbars/IncidentViewToolbar';
import IncidentView from '@/views/incident/IncidentView';
import IncidentList from '@/views/incident/IncidentList';
import DefaultLayout from '@/layout/DefaultLayout';
import { STATES } from '@/constants';

export const incidentWorkRoutes = [
  {
    path: '/incident-work',
    name: 'incident-work',
    components: {
      default: IncidentList,
      toolbar: IncidentListToolbar
    },
    meta: {
      type: STATES.IN_WORK,
      sortBy: 'UPDATED_AT',
      title: 'Обращения в работе',
      layout: DefaultLayout
    }
  },
  {
    path: '/incident-work/:id',
    name: 'incident-work-view',
    components: {
      default: IncidentView,
      toolbar: IncidentViewToolbar
    },
    meta: {
      layout: DefaultLayout,
      type: STATES.IN_WORK
    }
  },
  {
    path: '/incident-work/:id/more/:moreId?',
    name: 'incident-work-view-more',
    components: {
      default: IncidentView,
      toolbar: IncidentViewToolbar
    },
    meta: {
      layout: DefaultLayout,
      type: STATES.IN_WORK
    }
  }
];
